import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonUtilService } from '../service/common-util.service';
import { LargereceiptService } from '../service/largereceipt.service';

@Component({
  selector: 'app-errorpage',
  templateUrl: './errorpage.component.html',
  styleUrls: ['./errorpage.component.scss']
})
export class ErrorpageComponent implements OnInit {
  errorDescription:string;
  constructor(private route: ActivatedRoute, private largeReceiptService: LargereceiptService
  ,private commonUtilSvc:CommonUtilService) { 

    this.route.params.subscribe( params => this.errorDescription=(params.errorDesc));
  }

  ngOnInit(): void {

    this.commonUtilSvc.hideSpinner();
  }

}
